import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Loader from '../components/Loader';
import AuthRedirect from '../components/AuthRedirect';
import ProtectedPage from '../components/ProtectedPage';
import DashboardLayout from '../components/DashboardLayout';
import {
    DashboardPage,
    dashboard_pages,
} from '../utils/dashboard_pages';

//const Landing = React.lazy(() => import("../pages/Landing"));
const Login = React.lazy(() => import("../pages/Login"));
const Signup = React.lazy(() => import("../pages/Signup"));
const PasswordReset = React.lazy(() => import("../pages/PasswordReset"));


const generateDashboardRoutes = (pages: DashboardPage[]):React.ReactNode => {
    return pages.map((page) => {
        if (page.child) {
            return (
                <React.Fragment key={page.link}>
                    <Route path={page.link} element={<ProtectedPage><page.component /></ProtectedPage>} />
                    {generateDashboardRoutes(page.child)}
                </React.Fragment>
            );
        }
        return <Route key={page.link} path={page.link} element={<page.component />} />;
    });
};

const ProjectRoutes = () => {
    const auth_routes = [
        { path: '/login', component: Login },
        { path: '/signup', component: Signup },
        { path: '/password-reset', component: PasswordReset },
    ];

    function getLoader() {
        return (
            <div className="flex items-center justify-center min-h-screen p-5 bg-gray-100 min-w-screen">
                <Loader />
            </div>
        )
    }

    return (
        <React.Suspense fallback={getLoader()}>
            <Routes>
                {auth_routes.map((route, index) => {
                    const Component = route.component;
                    return <Route key={index} path={route.path} element={<AuthRedirect><Component /></AuthRedirect>} />
                })}

                <Route path="/dashboard" element={<DashboardLayout />}>
                    <Route index element={<Navigate to="home" replace />} />
                    {dashboard_pages.flatMap((group) => generateDashboardRoutes(group))}
                </Route>

                {/* Catch-all route for non-existent pages */}
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </React.Suspense>
    );
};

export default ProjectRoutes;
